<script>
    import FormControl from '../components/FormControl.svelte';
    import Loader from '../components/Loader.svelte';
    import AuthService from '../services/auth.service.js';

    export let user;
    export let params;

    let errors = {};
    let errorMessage = '';
    let loading = false;
    let payload = {};
    let resetPasswordData = {
        email: '',
        error: '',
        loading: false,
        sent: false
    };

    async function doLogin() {
        errorMessage = '';
        errors = {};
        loading = true;

        AuthService
            .login(payload)
            .then((response) => {
                if (response && response.message) {
                    errorMessage = response.message;
                } else if (response && response.data && response.data.token) {
                    localStorage.setItem(ENVIRONMENT.AUTH_TOKEN, response.data.token);
                    window.location = '/?v=' + Date.now();
                } else if (response && response.data && response.data.data && response.data.data.token) {
                    localStorage.setItem(ENVIRONMENT.AUTH_TOKEN, response.data.data.token);
                    window.location = '/?v=' + Date.now();
                }
            })
            .catch((e, data) => {
                console.log('E', e, data);
                errorMessage = (e || 'ERROR:UNKNOWN').toString();
                if (e && e.response && e.response.data && e.response.data.error) {
                    errorMessage = e.response.data.error;
                }
            })
            .finally(() => {
                setTimeout(() => loading = false, 1000);
            });
    }

    function externalLogin(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location = ENVIRONMENT.API_HOST + '/external-login';
    }

    function cleanResetPasswordData() {
        resetPasswordData = {
            email: '',
            error: '',
            loading: false,
            sent: false
        };
    }

    function openResetPasswordModal() {
        cleanResetPasswordData();
        jQuery('#modalResetPassword').modal('show');
    }

    function onRequestResetPassword() {
        resetPasswordData.loading = true;

        AuthService
            .requestResetPassword({email: resetPasswordData.email})
            .then((response) => {
                response = response ? response.data : null;
                if (!response.data || response.data.error) {
                    resetPasswordData.error = response.data.error;
                } else {
                    resetPasswordData.sent = true;
                }
            })
            .catch((e, data) => {
                resetPasswordData.error = (e || 'ERROR:UNKNOWN').toString();
                if (e && e.response && e.response.data && e.response.data.error) {
                    resetPasswordData.error = e.response.data.error;
                }
            })
            .finally(() => {
                setTimeout(() => resetPasswordData.loading = false, 1000);
            });
    }
</script>

<form on:submit|preventDefault="{onRequestResetPassword}">
    <div class="modal fade" id="modalResetPassword" tabindex="-1" role="dialog" aria-labelledby="modalResetPassword" aria-hidden="true">
        <div class="modal-dialog modal-650">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Reset password
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="col-md-12">
                        {#if resetPasswordData.loading}
                            <Loader />
                        {:else}
                            {#if resetPasswordData.sent}
                                <div class="alert alert-success mb-1">
                                    Email sent
                                </div>
                                <p>A password reset message was sent to your email address. Please click the link in the message to reset your password.</p>
                                <p>If you do not receive the password reset message within a few moments, please check your spam folder or other filtering tools.</p>
                            {:else}
                                <div class="form-group">
                                    <label for="external-email">*Email</label>
                                    <input required bind:value={resetPasswordData.email} class="form-control" type="email" placeholder="johndoe@email.com">
                                </div>
                                {#if resetPasswordData.error}
                                    <div class="alert alert-danger">
                                        <b>ERROR:</b> {resetPasswordData.error}
                                    </div>
                                {/if}
                            {/if}
                        {/if}
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    {#if !resetPasswordData.sent}
                        <button type="submit" class="btn btn-success" disabled={resetPasswordData.loading}>
                            Send reset password link
                        </button>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</form>

<main class="pt-3 container">
    <div class="row">
        <form
            class="col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-4 offset-lg-4"
            on:submit|preventDefault="{doLogin}">
            <fieldset>
                <legend class="pt-5 pb-2 text-center">
                    <img src="/img/Riverside-logo-full.gif">
                </legend>
                <FormControl
                    error="{errors.username}"
                    type="email"
                    label="Username"
                    bind:value={payload.username}
                    required autofocus />
                <FormControl
                    error="{errors.password}"
                    type="password"
                    label="Password"
                    bind:value={payload.password}
                    required />

                {#if errorMessage && !loading}
                    <output class="alert alert-danger d-block">
                        <strong>ERROR:</strong> {errorMessage}
                    </output>
                {/if}
                <div class="pt-2">
                    <button class="btn btn-primary" type="submit" disabled="{loading}">Login</button>
                    <span on:click={openResetPasswordModal} class="link-text text-primary float-right">Forgot password</span>
                    <p class="mt-3 link-text text-primary" type="submit" on:click={externalLogin}>Login with RRAS</p>
                </div>
            </fieldset>
        </form>
    </div>
</main>

<style>
    .link-text {
        text-decoration: underline;
        cursor: pointer;
    }
</style>
